var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListenimgbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7925 35.0784L38.1426 33.4285C43.3673 28.2038 43.3673 19.6793 38.1426 14.4546L39.7925 12.8047C45.9338 18.946 45.9338 28.9371 39.7925 35.0784Z",
    fill: "#324A5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7144 30.9987L34.0645 29.3488C37.0434 26.3698 37.0434 21.5117 34.0645 18.5327L35.7144 16.8828C39.61 20.7784 39.61 27.1031 35.7144 30.9987Z",
    fill: "#324A5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.29 38.6499L12.3867 30.3545V17.5219L28.29 9.22656V38.6499Z",
    fill: "#324A5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6125 6.80078C27.6042 6.80078 26.7793 7.62573 26.7793 8.63401V39.2489C26.7793 40.2572 27.6042 41.0822 28.6125 41.0822C29.6208 41.0822 30.4458 40.2572 30.4458 39.2489V8.63401C30.4458 7.62573 29.6208 6.80078 28.6125 6.80078Z",
    fill: "#324A5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46658 17.4297C4.68746 17.4297 4 18.0713 4 18.8963V28.9332C4 29.7123 4.64163 30.3998 5.46658 30.3998H11V17.5L5.46658 17.4297Z",
    fill: "#324A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenimgbox);
export default __webpack_public_path__ + "static/media/listenimgbox.fcee60849d4e9cfb9ae01e90a9b5a358.svg";
export { ForwardRef as ReactComponent };